import { render } from "./TextInput.vue?vue&type=template&id=2012198e&scoped=true"
import script from "./TextInput.vue?vue&type=script&lang=js"
export * from "./TextInput.vue?vue&type=script&lang=js"

import "./TextInput.vue?vue&type=style&index=0&id=2012198e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2012198e"]])

export default __exports__